/**
 * Display a number as a dollar amount.
 */
export function PrettyDollarNumber(props: { value: number; className?: string }) {
    const { value, className } = props;
    const roundedValue = Math.round(value);
    return (
        <span className={className}>
            ${roundedValue === value ? roundedValue : value.toFixed(2)}
        </span>
    );
}
